import * as React from 'react';
import { IFilterItem } from './IFilterItem';

interface IFilterContext {
  searchValue: string;
  selectedItemValues: (number | string)[];

  items: IFilterItem[];

  handleFilterClear(): void;
  handleFilterClose(): void;
  handleItemSelect(value: number | string): void;
  handleSearch: React.ChangeEventHandler<HTMLInputElement>;
  handleVisibilityToggle(): void;
}

const FilterContext = React.createContext<IFilterContext>({
  handleFilterClear: () => {
    throw new Error('handleFilterClear() not implemented');
  },
  handleFilterClose: () => {
    throw new Error('handleFilterClose() not implemented');
  },
  handleItemSelect: (value) => {
    throw new Error('handleItemSelect() not implemented');
  },
  handleSearch: (event) => {
    throw new Error('handleSearch() not implemented');
  },
  handleVisibilityToggle: () => {
    throw new Error('handleVisibilityToggle() not implemented');
  },
  items: [],
  searchValue: '',
  selectedItemValues: [],
});

export function FilterContextProvider({ value, children }: { value: IFilterContext; children: React.ReactNode }) {
  return <FilterContext.Provider value={value}>{children}</FilterContext.Provider>;
}

export function useFilterContext() {
  return React.useContext(FilterContext);
}
